// CP4.1: Vue 3 removed instance $on/$off/$emit (the event-bus pattern). mitt replaces it; exposed as
// app.config.globalProperties.$emitter (see main.js). Replaces former $root.$on / $root.$emit usage.
import mitt from 'mitt'

const emitter = mitt()
export default emitter
